<mat-expansion-panel [disabled]="translationMode">
  <mat-expansion-panel-header>
    <mat-panel-title [style.color]="translationMode ? '' : '#595c5f'" ><!--style="color:#595c5f;"-->
      <mat-icon style="margin-right: 10px;">visibility_lock</mat-icon>
      {{'visibility' | translate}}
    </mat-panel-title>
  </mat-expansion-panel-header>

  <div class="text-muted pb-2" style="font-size: 14px;line-height: 17px;">
    {{'condition_hint1' | translate}}
    <span style="cursor: help; color: var(--warmOrange);" matTooltip="{{'condition_hint3' | translate}}">
    {{'condition' | translate}}</span> {{'condition_hint2' | translate}}
    <span>{{'pass.evaluation' | translate}}</span>
  </div>

  <div class="d-flex justify-content-between my-3">

    @if(contextLicenseFree){
      <button  mat-button class="secondary-gray-button" (click)="openFreePublisherCTA()">
        <mat-icon>add_circle</mat-icon> {{'add_condition' | translate}}
      </button>
    }
    @else{
    @if (!disableAddFilters) {
      <button mat-button class="secondary-gray-button" id="btn-add" [matMenuTriggerFor]="filtersOptions">
        <mat-icon>add_circle</mat-icon> {{'add_condition' | translate}}
      </button>
    }

    @if (disableAddFilters) {
      <button mat-button class="secondary-gray-button"  (click)="deleteAllFilter()" [disabled]="!filtersData">
        <mat-icon class="material-symbols-outlined" style="color:red;">delete</mat-icon> Remove all
      </button>
    }
  }

</div>

<mat-menu #filtersOptions="matMenu">
  @for (filter of filterTypes; track filter; let index = $index) {
    <button mat-menu-item (click)="addFilterType(filter);" matTooltipPosition="after" matTooltipShowDelay="500" [matTooltip]="filter.tooltipKey | translate" [disabled]="disableAddFilters"> {{filter.translate | translate}} </button>
  }
</mat-menu>

@if (filtersData?.field !== undefined && filtersData?.value !== undefined) {
  <div>
    <div class="form-control p-2 px-3 mb-1 d-flex justify-content-between w-100">
      <div class="d-flex align-items-center">
        <span class="me-2">{{ filtersData?.field }}</span>
        <span class="font-italic me-2 text-muted">
          {{ getOperatorText(filtersData?.operator) | translate }}
        </span>
        <span>{{ filtersData?.value }}</span>
      </div>
      <div>
                <button mat-icon-button style="color:var(--warmOrange);" (click)="editFilterType(filtersData, '=')">
                    <mat-icon>edit</mat-icon>
                </button>
            </div>
        </div>
    </div>
}

    @if (filtersData?.and || filtersData?.or) {
<div>
        <div id="tree-section">
            <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="example-tree w-100 m-auto shadow-sm ">

                <mat-nested-tree-node *matTreeNodeDef="let node; when: hasGroup">
                    <div class="mat-tree-node border-bottom ">
                        <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.key">
                            <mat-icon class="mat-icon-rtl-mirror"> {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}</mat-icon>
                        </button>

                        @if (!isObject(node)) {
<div class="d-flex flex-row flex-wrap justify-content-start align-items-center ps-2">
                            <span class="p-1" style="color:black;" >##{{getKeysObject(node)}}</span>
                        </div>
}

                        @if (isObject(node)) {
<div class="d-flex flex-row flex-wrap justify-content-between align-items-center ps-2">
                            <div  class="d-flex flex-row justify-content-start align-items-center ps-2">
                                @if (node.field) {
<span class="p-1" style="color:black;" >++{{node.field}}  {{node.operator}}  {{node.value}}</span>
}
                                @if (node.and) {
<span class="p-1" style="color:black;" >{{'pass.widgets.filter.all_of' | translate}}</span>
}
                                @if (node.or) {
<span class="p-1" style="color:black;" >{{'pass.widgets.filter.any_of' | translate}}</span>
}
                            </div>

                            <div>
                                <button mat-icon-button  style="color:var(--warmOrange);" [matMenuTriggerFor]="filterEditList" > <!--(click)="addNewProperty(node,index);"-->
                                    <mat-icon>edit</mat-icon>
                                </button>

                                <mat-menu #filterEditList="matMenu">
                                    <button mat-menu-item (click)="toggleGroupKind(node, 'or')">{{'pass.widgets.filter.any_of' | translate}}</button>
                                    <button mat-menu-item (click)="toggleGroupKind(node, 'and')">{{'pass.widgets.filter.all_of' | translate}}</button>
                                </mat-menu>
                                
                                <button mat-icon-button  style="color:var(--warmOrange);" [matMenuTriggerFor]="filterAddList" [disabled]="getDisableNodeChilds(node)"> <!--(click)="addNewProperty(node,index);"-->
                                    <mat-icon>add_circle</mat-icon>
                                </button>

                                <mat-menu #filterAddList="matMenu">
                                    @for (type of filterTypes; track type) {
<button mat-menu-item
                                            (click)="addFilterTypeToNode(type, node)"
                                            matTooltipPosition="after" matTooltipShowDelay="500" [matTooltip]="type.tooltipKey | translate" 
                                            [disabled]="getDisableNodeChilds(node)">
                                    {{ type.translate | translate }}
                                    </button>
}
                                </mat-menu>

                                <button mat-icon-button style="color: red;"  (click)="deleteNode(node)"  [disabled]="!filtersData">
                                    <span class="material-symbols-outlined">delete</span>
                                </button>
                            </div>
                        </div>
}

                    </div>

                    <div [class.example-tree-invisible]="!treeControl.isExpanded(node)" role="group">
                    <ng-container matTreeNodeOutlet></ng-container>
                </div>
                </mat-nested-tree-node>

                <mat-nested-tree-node *matTreeNodeDef="let node; when: isComparison">
                    <div class="mat-tree-node border-bottom">
                        <div class="d-flex flex-row justify-content-start flex-wrap align-items-center ps-2">
                            <span class="p-1" style="color:black;" >{{node.field }}</span> 
                            <span class="p-1 font-italic text-muted" style="color:black;" >{{getOperatorText(node.operator) | translate}}</span>
                            <span class="p-1" style="color:black;" >{{node.value }}</span> 
                        </div>

                        <div>
                            <button mat-icon-button style="color:var(--warmOrange);"
                                    (click)="editFilterType(node, '=')">
                                <mat-icon>edit</mat-icon>
                            </button>
                            <button mat-icon-button style="color:red"
                                    (click)="deleteNode(node)">
                                <span class="material-symbols-outlined">delete</span>
                            </button>
                        </div>
                    </div>
                </mat-nested-tree-node>
            </mat-tree>   
        </div>
    </div>
}

</mat-expansion-panel>
